import React, { Component } from 'react'

export class about extends Component {
  render() {
    return (
        <div id="about">
          <div className="container section">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="about-text">
                  <h2>{this.props.data ? this.props.data.h2 : 'loading...'}</h2>
                  <p>{this.props.data ? this.props.data.paragraph : 'loading...'}</p>
                  <h3>Wie funktionierts?</h3>
                  <p>Bring einfach ein paar Pflanzen mit und sorge so für mehr Abwechslung auf dem Balkon und im Garten.
                  Du hast noch keine Pflanzen? Auch Spenden, Talente oder ein freundliches Lächeln lassen sich eintauschen.
                  </p>
                </div>
              </div>
              <div className="col-xs-12 col-md-6"> <img src="img/plants/_W7A9263_1.jpg" className="img-responsive" alt=""/> </div>
            </div>
          </div>
      </div>
    )
  }
}

export default about;
